<template>
  <div>
    <HeaderInPreview :isPreview="isPreview" :data="m_event" />
    <div class="list-company-overlay">
      <ListCompanyPreview />
    </div>
  </div>
</template>
<script>
import HeaderInPreview from '@/components/HeaderInPreview';
import ListCompanyPreview from '@/containers/entry/ListCompany/ListCompanyPreview.vue';

export default {
  name: 'LayoutPreviewListCompany',
  components: {
    HeaderInPreview,
    ListCompanyPreview
  },
  data: function () {
    return {
      isPreview: false,
      language: 'vi'
    };
  },

  watch: {},

  created() {
    const { query } = this.$route;

    if (typeof query.token !== 'undefined') {
      this.$store.dispatch('previewCompany', {
        company_token: query.token
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/style/devices.scss';
.list-company-overlay {
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
